<template>
  <b-tooltip
    position="is-top"
    multilined
    :active="tooltip.length > 0"
    content-class="custom-tooltip"
    :style="{
      position: 'absolute',
      top: top,
      right: right,
      height: 'fit-content',
    }"
  >
    <b-tag type="is-info" class="px-1" style="height: 12px">
      <p style="font-size: 10px">BETA</p>
    </b-tag>
    <template v-slot:content>
      <p
        style="width: 33rem; text-wrap: wrap; padding: 15px"
        v-html="tooltip"
      ></p>
    </template>
  </b-tooltip>
</template>

<script>
export default {
  props: {
    top: {
      type: String,
      default: "-0.75rem",
    },
    right: {
      type: String,
      default: "-0.25rem",
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.custom-tooltip {
  background: #167df0 !important;
  background: linear-gradient(
    90deg,
    rgba(22, 125, 240, 1) 0%,
    rgba(22, 107, 204, 1) 50%,
    rgba(27, 75, 122, 1) 100%
  ) !important;
  p,
  strong {
    color: white !important;
  }
}
</style>
